import _ from 'lodash';
import getCompositeColumnsMapping from './getCompositeColumnsMapping';
function getAllCompositeColumns() {
    return _.values(getCompositeColumnsMapping());
}
export default getAllCompositeColumns;
